export default __webpack_public_path__ + "static/media/egg.d5007b94.png";